import { WidgetContainer } from '../../../infrastructure/widgets/WidgetContainer';
import { WidgetConfig } from '../../../infrastructure/contracts/widget.contract';
import { StatisticsCard } from '../../../infrastructure/widgets/cards/StatisticsCard';
import { DeferredData } from '../../../infrastructure/adapters/DeferredDataAdapter';

export interface KPIWidgetData {
  primaryValue: number | string;
  secondaryValue?: number | string;
  trend?: number;
  delta?: number;
  comparison?: string;
  status?: 'success' | 'warning' | 'danger' | 'info';
}

export interface SharedKPIWidgetProps {
  config: WidgetConfig;
  dataQuery: {
    data?: DeferredData<KPIWidgetData>;
    isLoading: boolean;
    isError: boolean;
    error?: Error | null;
    refetch?: () => void;
  };
  color?: 'primary' | 'success' | 'warning' | 'error' | 'info';
}

export function SharedKPIWidget({
  config,
  dataQuery,
  color = 'primary',
}: SharedKPIWidgetProps) {
  const { data: deferred, isLoading, isError, error, refetch } = dataQuery;

  const isWidgetLoading = isLoading || deferred?.loading;
  const widgetError = isError 
    ? error?.message 
    : deferred?.error;

  const kpiData = deferred?.data;

  return (
    <WidgetContainer
      config={config}
      isLoading={isWidgetLoading}
      isError={!!widgetError}
      errorMessage={widgetError}
      onRefresh={refetch}
    >
      {deferred?.unavailable ? (
        <div className="flex h-full items-center justify-center p-4">
          <p className="text-body-sm text-on-surface-variant italic text-center">
            Metric unavailable.
          </p>
        </div>
      ) : kpiData ? (
        <StatisticsCard
          title={config.title}
          primaryValue={kpiData.primaryValue}
          secondaryValue={kpiData.secondaryValue}
          trend={kpiData.trend}
          delta={kpiData.delta}
          comparison={kpiData.comparison}
          status={kpiData.status}
          icon={config.icon}
          color={color}
        />
      ) : null}
    </WidgetContainer>
  );
}
